module.exports = __webpack_public_path__ + "media/images/preview_recipe_3-69e1439ba9fb77fe5772be9b6e60fbc0.webp";